export const environment = {
  production: false,
  apiUrl: 'https://xvivo-api-dev.up2technology.com/api/v1',
  language: 'en',
  buildNumber: 'BUILD_NUMBER' // updated in the pipeline
};